// extracted by mini-css-extract-plugin
module.exports = {"Page404":"Page404_Page404__Dedt_","ErrorNum":"Page404_ErrorNum__2UF0I","Tit":"Page404_Tit__2myAB"};